module.exports = __webpack_public_path__ + "img/server4-2.0b574aaf.png";